<script setup lang="ts">
import { computed } from 'vue';
import { any, number, bool } from 'vue-types';
import { Skeleton } from 'ant-design-vue';

const props = defineProps({
  total: number().def(1),
  class: any(),
  title: bool().def(true),
  paragraph: bool().def(true),
  avatar: bool().def(true),
});
const array = computed(() => Array.from(Array(props.total).keys()));
</script>

<template>
  <div v-for="index in array" :key="index" :class="$props.class">
    <Skeleton
      :title="title"
      :paragraph="paragraph"
      :avatar="avatar"
      active
      class="mb-2"
    />
  </div>
</template>
